// extracted by mini-css-extract-plugin
export default {"pointsAwarded":"PointsAwarded_pointsAwarded__aLxNu"};